<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="LTAPoliciesForm" (ngSubmit)="Validate(LTAPoliciesForm)" #LTAPoliciesForm="ngForm"
        novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Reimbursement Policy
                </div>
                <div class="card-body">
                    <div class="ms-5">
                        <div class="row mb-2">
                            <div class="col-md-2 align-self-center">
                                <label for="RuleName" class="form-label text-label-dark">Reimbursement Rule Name
                                    :</label>
                            </div>
                            <div class="col-md-5">
                                <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                    id="RuleName" name="RuleName" [(ngModel)]="DetailDate.ReimbursementRuleName"
                                    #RuleName="ngModel" maxlength="100" required>
                                <div class="invalid-feedback">
                                    Please Enter Reimbursement Rule Name!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2 align-self-center">
                                <label for="RuleName" class="text-label-dark">Reimbursement Type :</label>
                            </div>
                            <div class="col-md-4">
                                <ng-select name="Reimbursementtype" id="Reimbursementtype" [items]="ReimbursementLoad"
                                    bindLabel="ReimbursementType" bindValue="ESS_ReimbursementTypeID"
                                    [(ngModel)]="DetailDate.ESS_ReimbursementTypeID" #Reimbursementtype="ngModel"
                                    placeholder="Select Reimbursement type" required>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select Reimbursement Type!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="DefaultRule" class="form-label text-label-dark">Employee Type:</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                        *ngIf="(this.DetailDate.ESS_ReimbursementRuleId == 0) || (this.DetailDate.ESS_ReimbursementRuleId > 0 && common.ToLowerCase(DetailDate.EmpType) == 'front')">
                                        <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                            [(ngModel)]="DetailDate.EmpType" [ngModelOptions]="{standalone: true}" (change)="GetApplicability()"
                                            [disabled]="DetailDate.ESS_ReimbursementRuleId > 0" required>
                                        Front Office
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                        *ngIf="(this.DetailDate.ESS_ReimbursementRuleId == 0) || (this.DetailDate.ESS_ReimbursementRuleId > 0 && common.ToLowerCase(DetailDate.EmpType) == 'back')">
                                        <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                            [(ngModel)]="DetailDate.EmpType" [ngModelOptions]="{standalone: true}" (change)="GetApplicability()"
                                            [disabled]="DetailDate.ESS_ReimbursementRuleId > 0" required>
                                        Back Office
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="DefaultRule" class="form-label text-label-dark">Default Policy :</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true name="DefaultRule"
                                            [(ngModel)]="DetailDate.DefaultRule" [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false name="DefaultRule"
                                            [(ngModel)]="DetailDate.DefaultRule" [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="Description" class="form-label text-label-dark">Is Description
                                    mandatory:</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true name="Description"
                                            [(ngModel)]="DetailDate.IsDescriptionMandatory"
                                            [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false name="Description"
                                            [(ngModel)]="DetailDate.IsDescriptionMandatory"
                                            [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="IsReceiptMandatory" class="form-label text-label-dark">
                                    Limit For Attachment :</label>
                            </div>
                            <div class="col-md-2">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true
                                            name="IsReceiptMandatory" [(ngModel)]="DetailDate.IsReceiptMandatory"
                                            [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false
                                            name="IsReceiptMandatory" [(ngModel)]="DetailDate.IsReceiptMandatory"
                                            [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="input-group mb-3">
                                    <input type="text" maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                        placeholder="Ex. 01" id="LimitforAttachment" name="LimitforAttachment"
                                        [(ngModel)]="DetailDate.AmountLimit" #AmountLimit="ngModel"
                                        [disabled]="!DetailDate.IsReceiptMandatory" required>
                                    <span class="input-group-text" id="basic-LimitforAttachment">only</span>
                                    <!-- <div class="invalid-feedback">
                                        Please enter maximum days 365!
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="Description" class="form-label text-label-dark">Is LTA open for
                                    Request:</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true
                                            name="IsReimbursementOpen" [(ngModel)]="DetailDate.IsReimbursementOpen"
                                            [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false
                                            name="IsReimbursementOpen" [(ngModel)]="DetailDate.IsReimbursementOpen"
                                            [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="DetailDate.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && DetailDate.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                    *ngIf="(this.common.PageRight.IsAdd && this.DetailDate.ESS_ReimbursementRuleId == 0) || (this.common.PageRight.IsEdit && this.DetailDate.ESS_ReimbursementRuleId > 0)"><i
                        class="bi bi-save2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>